import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { LlmProviderView } from "./LlmProviderView";
import { LlmProviderViewStore } from "../../store/LlmProviderViewStore";
import { useStore } from "../../../../hooks";

export const LlmProviderViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/llmProvider/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new LlmProviderViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <LlmProviderView llmProviderViewStore={store} />
      </PageLayout>
    </div>
  );
});
